import useBoundStore from '../../store';
import { shallow } from 'zustand/shallow';
import { useMemo } from 'react';

export type ApartmentSort = {
  field: string | undefined;
  direction: string | undefined;
};

const useApartmentsSortQuery = (): ApartmentSort => {
  const storeParams = useBoundStore(
    ({ fieldSort, directionSort }) => ({
      fieldSort,
      directionSort,
    }),
    shallow,
  );

  const sortByField = useMemo(() => {
    const { fieldSort, directionSort } = storeParams;

    return {
      field: fieldSort,
      direction: directionSort,
    };
  }, [storeParams]);

  return sortByField;
};

export default useApartmentsSortQuery;
